import { render, staticRenderFns } from "./lodgeTab.vue?vue&type=template&id=f8078a5e&scoped=true&"
import script from "./lodgeTab.vue?vue&type=script&lang=js&"
export * from "./lodgeTab.vue?vue&type=script&lang=js&"
import style0 from "./lodgeTab.vue?vue&type=style&index=0&id=f8078a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8078a5e",
  null
  
)

export default component.exports